import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import SaveIcon from '@material-ui/icons/Save';
import Edit from '@material-ui/icons/Edit';
import { Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tabs, Tab, Card, List, ListItem, CardContent, RadioGroup } from '@material-ui/core';
import { GetReglas, DropApiKey, AddApiKey } from 'App/Administracion/Actions';
import { AdministracionContext } from "App/Administracion/store";
import { LayoutContext } from "App/Layout/store";
import { GetTags } from "App/Layout/Actions";
import moment from 'moment';
import axios from 'axios';
import _ from 'underscore';
import { TwitterPicker } from 'react-color'
import schema from './schema'
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css'
import Select from 'react-select';

function initialIsCapital(word) {
    return word[0] !== word[0].toLowerCase();
}

const traverseSchema = (obj) => {
    var ret = []
    for (const [key, value] of Object.entries(obj)) {
        if (initialIsCapital(key)) {
            var r = { key: key, title: key, description: value.description }
            if (value.type == "object" || value.type == "array") {
                r.children = traverseSchema(value)
                r.value = value
                //delete r.key
            }
            ret.push(r)
        }
    }
    return ret;
}

const opcionesSchema = traverseSchema(schema)

const buscaClaves = (array, obj = schema, path = '') => {
    var ret = []
    for (const [key, value] of Object.entries(obj)) {
        if (value.type == "object" || value.type == "array") {
            ret = [...ret, ...buscaClaves(array, value, `${path}${key}${(value.type == "array" ? "/" : ".")}`)]
        } else if (array.includes(key)) {
            ret.push({ ...value, type: value.type == "string" ? value.description?.indexOf("Fecha") > -1 ? "date" : "text" : "number", name: key, path })
        }
    }
    return ret;
}

const filtraClaves = (texto, obj) => {
    if (!obj) obj = JSON.parse(JSON.stringify(opcionesSchema))
    if (!texto) return obj
    for (var i in obj) {
        if (!obj[i].children) {
            if (String(obj[i].title).toLowerCase().indexOf(texto.toLowerCase()) < 0 && String(obj[i].description).toLowerCase().indexOf(texto.toLowerCase()) < 0) {
                delete obj[i]
            }
        } else {
            filtraClaves(texto, obj[i].children)
            if (!obj[i].children.some(e => e)) {
                delete obj[i]
            }
        }
    }
    return obj;
}

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

function Reglas(props) {
    const { classes, theme } = props;
    const administracionContext = useContext(AdministracionContext);
    const layoutContext = useContext(LayoutContext);
    const [regla, setRegla] = useState({ abrir: false, Tipo: -1, Condicion: "", Accion: { Tipo: -1, Parametros: {} } });
    const [tab, setTab] = useState(0)
    const [tags, setTags] = useState([])
    const [color, setColor] = useState()
    const [modo, setModo] = useState()
    const [condicion, setCondicion] = useState([])

    useEffect(() => {
        GetReglas(administracionContext.dispatch)
        GetTags(layoutContext.dispatch)
    }, []);

    useEffect(() => {
        if (!regla.abrir) {
            setCondicion([]);
            return;
        }
        var condicion = [];
        try {
            const parsed = JSON.parse(regla.Condicion);
            if (Array.isArray(parsed)) {
                condicion = parsed;
                setModo(0);
            } else {
                throw new Error("Condicion is not an array of rules");
            }
        } catch (e) {
            if (!regla.Condicion) {
                setModo(0);
            } else {
                setModo(1);
            }
        }
        setCondicion(condicion);
    }, [regla.abrir]);

    useEffect(() => {
        setTags(layoutContext.state.tags)
    }, [layoutContext.state.tags])

    function guardarEtiquetas(datos) {
        axios.post("/api/Administracion/Etiquetas/Guardar", datos).then(o => {
            GetTags(layoutContext.dispatch)
        }).catch(e => {
        });
    }

    var TiposEventos = [
        { ID: 0, Nombre: "Documento Creado" },
        { ID: 1, Nombre: "Documento Emitido es Rechazado por el SII" },
        { ID: 2, Nombre: "Documento Emitido Recibe Respuesta Comercial" },
        { ID: 3, Nombre: "Documento Recibido" },
        //{ ID: 4, Nombre: "Documento Emitido Cambia de Estado en el SII" }
    ];

    var TiposAccion = [
        { ID: 0, Nombre: "Enviar Correo" },
        { ID: 1, Nombre: "Respuesta Comercial" },
        { ID: 2, Nombre: "WebHook" },
        { ID: 3, Nombre: "Agregar Etiqueta" }
    ];

    var respuestas = [
        { Accion: 'ERM', texto: 'Acuse de Recibo de Mercaderías y Servicios Ley 19.983' },
        { Accion: 'ACD', texto: 'Acepta Contenido del Documento' },
        { Accion: 'RCD', texto: 'Reclamo al contenido del documento' },
        { Accion: 'RFP', texto: 'Reclamo por falta parcial de mercaderías' },
        { Accion: 'RFT', texto: 'Reclamo por falta total de mercaderías' }
    ];

    var nuevaRegla =
        <Dialog
            fullWidth
            maxWidth="md"
            open={regla.abrir}
            onClose={() => setRegla({ ...regla, abrir: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Agregar Regla</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <form className={classes.container} noValidate autoComplete="off">
                        <Grid container>
                            <Grid xs={2}>&nbsp;</Grid>
                            <Grid xs={8}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Evento"
                                    margin="dense"
                                    InputLabelProps={{ shrink: true }}
                                    className={classes.dense}
                                    value={regla.Tipo}
                                    variant="outlined"
                                    onChange={e => setRegla({ ...regla, Tipo: e.target.value, Accion: { Tipo: -1, Parametros: {} } })}>
                                    {TiposEventos.map(option => (
                                        <MenuItem key={option.ID} value={option.ID}>
                                            {option.Nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                        {regla.Tipo > -1 && <div>
                            {modo ? <Grid container>
                                <Grid xs={2}>&nbsp;</Grid>
                                <Grid xs={8}>
                                    <TextField
                                        fullWidth
                                        id="outlined-textarea"
                                        label="Condiciones"
                                        placeholder='Ej: DTE.Documento.Encabezado.Receptor.RUTReceptor == "55555555-5"'
                                        multiline
                                        margin="normal"
                                        value={regla.Condicion}
                                        variant="outlined"
                                        onChange={e => setRegla({ ...regla, Condicion: e.target.value })}
                                    />
                                </Grid>
                            </Grid> : null}
                            <Grid container>
                                <Grid xs={2}>&nbsp;</Grid>
                                <Grid xs={8}>
                                    {!modo?<Button onClick={() => setCondicion([...condicion, {}])}>Agregar Condicion</Button>:null}
                                    <Button className='float-right' onClick={() => {if(!modo) setRegla({ ...regla, Condicion: "" }); setModo(!modo) }}>Cambiar a Condición {!modo?"Avanzada":"Simple"}</Button>
                                </Grid></Grid>
                            {modo?null:condicion.map((e, i) => <Grid container>
                                <Grid xs={2}>&nbsp;</Grid>
                                <Grid xs={8}>
                                    <Card style={{ marginBottom: 5 }}>
                                        <CardContent>
                                            <Grid container>
                                                <Grid xs={6}>
                                                    <h5>Campos DTE</h5>
                                                    <TextField value={e.filtro} onChange={ev => {
                                                        ev.preventDefault();
                                                        var c = [...condicion]
                                                        c[i].filtro = ev.target.value
                                                        setCondicion(c)
                                                    }} />
                                                    <Tree
                                                        treeData={filtraClaves(e.filtro)[0]?.children || []}
                                                        multiple
                                                        selectedKeys={e.seleccionados?.map(e => e.name)}
                                                        onSelect={(s, b) => {
                                                            var c = [...condicion]
                                                            s = buscaClaves(s).filter(e => e.type != "array" && e.type != "object")
                                                            c[i].seleccionados = s.map(d => (c[i].seleccionados || []).find(f => d.name == f.name) || d)
                                                            setCondicion(c)
                                                        }}
                                                        showIcon={false} />
                                                </Grid>
                                                <Grid xs={6}>
                                                    <h5>Condiciones</h5>
                                                    {e.seleccionados?.map((c, j) => {
                                                        return <>
                                                            <p><small><strong>{c.name}</strong><span>&nbsp;
                                                                <Icon color="error" style={{ margin: 0 }} className={classes.iconHover} onClick={(evt) => {
                                                                    evt.preventDefault();
                                                                    var c = [...condicion]
                                                                    c[i].seleccionados.splice(j, 1)
                                                                    setCondicion(c)
                                                                }}>
                                                                    <RemoveCircle />
                                                                </Icon>
                                                            </span></small></p>
                                                            {c.description ? <small>{c.description}</small> : null}
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    select
                                                                    fullWidth
                                                                    label="Filtro"
                                                                    margin="dense"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    className={classes.dense}
                                                                    value={c.radio || 0}
                                                                    variant="outlined"
                                                                    onChange={evt => {
                                                                        evt.preventDefault();
                                                                        var co = [...condicion]
                                                                        co[i].seleccionados[j].radio = evt.target.value;
                                                                        setCondicion(co)
                                                                    }}>
                                                                    {["Igual a", "Menor a", "Mayor a", "Menor o igual a", "Mayor o igual a", "Entre", "En lista"].map((l, k) => {
                                                                        if (c.type == "text" && k > 3 && k < 6) return;
                                                                        return <MenuItem key={k} value={k}>
                                                                            {c.type == "text" ? (["Igual a", "Empieza con", "Termina con", "Contiene"].find((o, f) => f == k) || l) : l}
                                                                        </MenuItem>
                                                                    })}
                                                                </TextField>
                                                            </FormControl>
                                                            <TextField
                                                                type={c.type}
                                                                value={c.de}
                                                                select={c.enum ? true : false}
                                                                onChange={ev => {
                                                                    ev.preventDefault();
                                                                    var co = [...condicion]
                                                                    co[i].seleccionados[j].de = ev.target.value;
                                                                    setCondicion(co)
                                                                }}
                                                            >
                                                                {c.enum?.map(op => <MenuItem key={op} value={op}>
                                                                    {op}
                                                                </MenuItem>)}
                                                            </TextField>{c.radio == 6 ? <Icon color="primary" disabled={!c.de} onClick={ev => {
                                                                ev.preventDefault();
                                                                var co = [...condicion]
                                                                co[i].seleccionados[j].lista = [...(c.lista || []), c.de];
                                                                setCondicion(co)
                                                            }}><AddCircle /></Icon> : null}
                                                            {c.radio == 5 ? <>y <TextField
                                                                type={c.type}
                                                                value={c.a}
                                                                select={c.enum ? true : false}
                                                                onChange={ev => {
                                                                    ev.preventDefault();
                                                                    var co = [...condicion]
                                                                    co[i].seleccionados[j].a = ev.target.value;
                                                                    setCondicion(co)
                                                                }}
                                                            /></> : null}
                                                            {c.radio == 6 ? <List>
                                                                {c.lista?.map((f, k) => <ListItem>{f} &nbsp;
                                                                    <Icon color="error" style={{ margin: 0 }} className={classes.iconHover} onClick={(evt) => {
                                                                        evt.preventDefault();
                                                                        var c = [...condicion]
                                                                        c[i].seleccionados[j].lista.splice(k, 1)
                                                                        setCondicion(c)
                                                                    }}>
                                                                        <RemoveCircle />
                                                                    </Icon></ListItem>)}
                                                            </List> : null}

                                                        </>
                                                    }
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card></Grid>
                            </Grid>)}
                            <Grid container>
                                <Grid xs={2}>&nbsp;</Grid>
                                <Grid xs={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            fullWidth
                                            label="Accion"
                                            margin="dense"
                                            InputLabelProps={{ shrink: true }}
                                            className={classes.dense}
                                            value={regla.Accion.Tipo}
                                            variant="outlined"
                                            onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Tipo: e.target.value, Parametros: {} } })}>
                                            {TiposAccion.filter(o => o.ID == 1 ? regla.Tipo == 3 : true).map(option => (
                                                <MenuItem key={option.ID} value={option.ID}>
                                                    {option.Nombre}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {regla.Accion.Tipo == 0 &&
                                <div>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                fullWidth
                                                id="outlined-textarea"
                                                label="Para"
                                                placeholder="Ej: correo@dominio.com, correo2@dominio.com"
                                                multiline
                                                margin="normal"
                                                value={regla.Accion.Parametros.Listado}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Listado: e.target.value } } })}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                fullWidth
                                                id="outlined-textarea"
                                                label="Título"
                                                placeholder="Ej: Nuevo Documento"
                                                margin="normal"
                                                value={regla.Accion.Parametros.Titulo}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Titulo: e.target.value } } })}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                fullWidth
                                                id="outlined-textarea"
                                                label="Contenido"
                                                placeholder="Ej: Nuevo documento de {DTE.Documento.Encabezado.Emisor.RznSoc}"
                                                multiline
                                                margin="normal"
                                                value={regla.Accion.Parametros.Contenido}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Contenido: e.target.value } } })}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>}
                            {regla.Accion.Tipo == 1 &&
                                <div>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                select
                                                fullWidth
                                                label="Accion"
                                                margin="dense"
                                                InputLabelProps={{ shrink: true }}
                                                className={classes.dense}
                                                value={regla.Accion.Parametros}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: e.target.value } })}>
                                                {respuestas.map(option => (
                                                    <MenuItem key={option.Accion} value={option.Accion}>
                                                        {option.texto}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </div>}
                            {regla.Accion.Tipo == 2 &&
                                <div>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                fullWidth
                                                id="outlined-textarea"
                                                label="Url"
                                                placeholder="Ej: https://www.dominio.com/endpoint"
                                                multiline
                                                margin="normal"
                                                value={regla.Accion.Parametros.Url}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Url: e.target.value } } })}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <TextField
                                                fullWidth
                                                id="outlined-textarea"
                                                label="Contenido"
                                                placeholder='Ej: {
                                                "RUT":"{DTE.Documento.Encabezado.Emisor.RUTEmis}",
                                                "RazonSocial":"{DTE.Documento.Encabezado.Emisor.RznSoc}"
                                            }'
                                                margin="normal"
                                                value={regla.Accion.Parametros.Contenido}
                                                variant="outlined"
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Contenido: e.target.value } } })}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container style={{ marginTop: 8 }}>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <Tooltip title="Agregar Encabezado">
                                                <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                                                    evt.preventDefault();
                                                    var Encabezado = (regla.Accion.Parametros.Encabezado || {})
                                                    Encabezado[""] = "";
                                                    setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Encabezado } } })
                                                }}>
                                                    <AddCircle />
                                                </Icon>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                    {
                                        (Object.entries(regla.Accion.Parametros.Encabezado || {})).map(([k, v], i) => {
                                            return <Grid container>
                                                <Grid xs={2}>&nbsp;</Grid>
                                                <Grid xs={3}>
                                                    <TextField
                                                        style={{ marginRight: 16 }}
                                                        fullWidth
                                                        id="outlined-textarea"
                                                        label="Encabezado"
                                                        placeholder='Encabezado'
                                                        margin="normal"
                                                        value={k}
                                                        variant="outlined"
                                                        onChange={e => {
                                                            var Encabezado = Object.fromEntries(
                                                                Object.entries(regla.Accion.Parametros.Encabezado).map(([key, value], j) => i === j ? [e.target.value, value] : [key, value])
                                                            )
                                                            setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Encabezado } } })
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid xs={3}>
                                                    <TextField
                                                        style={{ marginLeft: 16 }}
                                                        fullWidth
                                                        id="outlined-textarea"
                                                        label="Valor"
                                                        placeholder='Valor'
                                                        margin="normal"
                                                        value={v}
                                                        variant="outlined"
                                                        onChange={e => {
                                                            var Encabezado = Object.fromEntries(
                                                                Object.entries(regla.Accion.Parametros.Encabezado).map(([key, value], j) => i === j ? [key, e.target.value] : [key, value])
                                                            )
                                                            setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Encabezado } } })
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid xs={2}>
                                                    <Tooltip title="Eliminar Encabezado">
                                                        <Icon color="error" style={{ margin: 16, marginTop: 32 }} className={classes.iconHover} onClick={(evt) => {
                                                            evt.preventDefault();
                                                            var Encabezado = Object.fromEntries(
                                                                Object.entries(regla.Accion.Parametros.Encabezado).filter((o, j) => i !== j)
                                                            )
                                                            setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { ...regla.Accion.Parametros, Encabezado } } })
                                                        }}>
                                                            <RemoveCircle />
                                                        </Icon>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        })
                                    }
                                </div>}
                            {regla.Accion.Tipo == 3 &&
                                <div>
                                    <Grid container>
                                        <Grid xs={2}>&nbsp;</Grid>
                                        <Grid xs={8}>
                                            <Select
                                                isMulti
                                                placeholder="Etiqueta"
                                                className={classes.dense}
                                                value={(regla.Accion.Parametros.IdTag && !regla.Accion.Parametros.IdTag?.map ? [regla.Accion.Parametros.IdTag] : regla.Accion.Parametros.IdTag)?.map(e => ({ value: e, label: layoutContext.state.tags.find(t => t.id_tag == e)?.nombre }))}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 })
                                                }}
                                                onChange={e => setRegla({ ...regla, Accion: { ...regla.Accion, Parametros: { IdTag: e.map(d => d.value) } } })}
                                                options={layoutContext.state.tags.map(option => ({label:option.nombre, value: option.id_tag}))}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>}
                        </div>
                        }
                    </form>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setRegla({ ...regla, abrir: false })} color="primary">
                    Cerrar
                </Button>
                <Button onClick={() => {
                    try{
                        if(regla.Accion.Parametros.IdTag && !regla.Accion.Parametros.IdTag?.map){
                            regla.Accion.Parametros.IdTag = [regla.Accion.Parametros.IdTag]
                        }
                    }catch{}
                    axios.post('/api/Administracion/Reglas/Agregar', { ...regla, Condicion: modo?regla.Condicion:condicion }).then(e => { GetReglas(administracionContext.dispatch); alert(e) }).catch((e) => {
                /*alert(e.response.data.Mensaje)*/;
                    }).finally(() => {
                        setRegla({ ...regla, abrir: false });
                    })
                }} color="secondary">
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>

    return (
        <div>
            <Tabs
                value={tab}
                onChange={(e, v) => setTab(v)}
                indicatorColor="primary"
                textColor="primary"
                centered
                variant="fullWidth"
            >
                <Tab label="Reglas" />
                <Tab label="Etiquetas" />
            </Tabs>
            {tab == 0 ? <TabContainer>
                <Grid container spacing={24}>
                    <Grid item sm={12}>
                        <Typography variant="h5">Reglas de Negocio</Typography>
                    </Grid>
                    <Grid item sm={12} className={classes.textAlignRight}>
                        <Tooltip title="Agregar Regla">
                            <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={() => setRegla({ ...regla, abrir: true })}>
                                <AddCircle />
                            </Icon>
                        </Tooltip>
                    </Grid>
                    <Grid item sm={12}>
                        <Paper className={classes.root}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Regla</TableCell>
                                        <TableCell>Fecha de Creacion</TableCell>
                                        <TableCell>Tipo Evento</TableCell>
                                        {/* <TableCell>Condicion</TableCell> */}
                                        <TableCell>Tipo Accion</TableCell>
                                        {/* <TableCell>Parametros</TableCell> */}
                                        <TableCell>Activa</TableCell>
                                        <TableCell>Editar</TableCell>
                                        <TableCell>Eliminar</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(administracionContext.state.reglas.listado).map((regla, ix) => {
                                        return (
                                            <TableRow key={ix}>
                                                <TableCell component="th" scope="row">
                                                    {regla.IdRegla}
                                                </TableCell>
                                                <TableCell>{moment(regla.FechaCreacion).format("L")}</TableCell>
                                                <TableCell>{(_.findWhere(TiposEventos, { ID: regla.Tipo }) || {}).Nombre}</TableCell>
                                                {/* <TableCell>{regla.Condicion}</TableCell> */}
                                                <TableCell>{regla.Accion.replace(/([A-Z])/g, ' $1')
                                                    .replace(/^./, function (str) { return str.toUpperCase(); })}</TableCell>
                                                {/* <TableCell>{(regla.Argumentos || "").slice(0, 50)}</TableCell> */}
                                                <TableCell>
                                                    <Switch
                                                        checked={regla.Activa}
                                                        onChange={() => {
                                                            axios.post('/api/Administracion/Reglas/Activa', { IdRegla: regla.IdRegla }).then(e => { regla.Activa = !regla.Activa; administracionContext.dispatch({ type: "reglasListado", listado: administracionContext.state.reglas.listado }); }).catch((e) => {
                                                        /*alert(e.response.data.Mensaje)*/;
                                                            })
                                                        }}
                                                        color="primary"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title="Editar Regla">
                                                        <Icon color="warning" className={classes.iconHover} onClick={(evt) => {
                                                            evt.preventDefault();
                                                            const newParams = JSON.parse(regla.Argumentos);
                                                            const newTipo = (regla.Accion == "Etiqueta" ? 3 : regla.Accion == "WebHook" ? 2 : regla.Accion == "EnviaCorreo" ? 0 : 1);
                                                            if (newTipo === 0 && Array.isArray(newParams.Listado)) {
                                                                newParams.Listado = newParams.Listado.join();
                                                            }
                                                            setRegla({
                                                                ...regla,
                                                                abrir: true,
                                                                Accion: {
                                                                    Tipo: newTipo,
                                                                    Parametros: newParams
                                                                }
                                                            });
                                                        }}>
                                                            <Edit />
                                                        </Icon>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title="Eliminar Regla">
                                                        <Icon color="error" className={classes.iconHover} onClick={(evt) => {
                                                            evt.preventDefault();
                                                            layoutContext.dispatch({
                                                                type: "setAlert", Alert: {
                                                                    Accion: () => axios.post('/api/Administracion/Reglas/Eliminar', { IdRegla: regla.IdRegla }).then(e => administracionContext.dispatch({ type: "reglasListado", listado: administracionContext.state.reglas.listado.filter(ee => ee != regla) })).catch((e) => {
                                                                    /*alert(e.response.data.Mensaje)*/;
                                                                    }),
                                                                    titulo: "¿Está seguro?",
                                                                    contenido: "¿Está seguro que desea eliminar esta Regla? Esta acción es irreversible."
                                                                }
                                                            })
                                                        }}>
                                                            <RemoveCircle />
                                                        </Icon>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                </Grid>
            </TabContainer> :
                <TabContainer>
                    <Grid container spacing={24}>
                        <Grid item sm={12}>
                            <Typography variant="h5">Etiquetas</Typography>
                        </Grid>
                        <Grid item sm={12} className={classes.textAlignRight}>
                            {!_.isEqual(tags, layoutContext.state.tags) ? <Tooltip title="Guardar Cambios">
                                <Button onClick={(evt) => {
                                    evt.preventDefault();
                                    if (window.confirm("¿Desea guardar estos cambios?"))
                                        guardarEtiquetas(tags)
                                }}>
                                    <SaveIcon />
                                </Button>
                            </Tooltip> : null}
                            <Tooltip title="Agregar Etiqueta">
                                <Button onClick={e => {
                                    e.preventDefault()
                                    setTags([...tags, { nombre: "", color: "FCCB00" }])
                                }} size='sm' outline color="primary">
                                    <AddCircle />
                                </Button>
                            </Tooltip>
                        </Grid>
                        {tags.map((e, i) => <Grid container>
                            <Grid sm={2}>
                                <div onClick={e => {
                                    e.preventDefault()
                                    setColor(i)
                                }} style={{ width: '2rem', height: '2rem', backgroundColor: `#${e.color}` }}></div>
                                {color === i ? <div style={{
                                    position: 'absolute',
                                    zIndex: '2'
                                }}><div style={{
                                    position: 'fixed',
                                    top: '0px',
                                    right: '0px',
                                    bottom: '0px',
                                    left: '0px'
                                }} onClick={() => setColor(undefined)} /> <TwitterPicker
                                        colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548"]}
                                        onChange={e => {
                                            const Tags = [...tags]
                                            const Tag = { ...Tags[i] }
                                            Tag.color = e.hex.substring(1)
                                            Tags[i] = Tag
                                            setTags(Tags)
                                            setColor(undefined)
                                        }} /></div> : null}
                            </Grid>
                            <Grid sm={7}>
                                <TextField type='text' name='Nombre' id={`nameIconsTag${i}`} placeholder='Etiqueta' onChange={
                                    e => {
                                        const Tags = [...tags]
                                        const Tag = { ...Tags[i] }
                                        Tag.nombre = e.target.value
                                        Tags[i] = Tag
                                        setTags(Tags)
                                    }} value={e.nombre} />
                            </Grid>
                            <Grid sm={2}>
                                <Button size='sm' outline color="danger" onClick={evt => {
                                    evt.preventDefault()
                                    if (!e.id_tag || window.confirm("Desea borrar esta Etiqueta?")) {
                                        const Tags = [...tags]
                                        Tags.splice(i, 1)
                                        setTags(Tags)
                                    }
                                }}>
                                    <Icon color="error">
                                        <RemoveCircle />
                                    </Icon>
                                </Button>
                            </Grid>
                        </Grid>
                        )}
                    </Grid>
                </TabContainer>}
            {nuevaRegla}
        </div>
    )
}

Reglas.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Reglas);